import { render, staticRenderFns } from "./editCompanyModal.vue?vue&type=template&id=2df34d1e&scoped=true"
import script from "./editCompanyModal.vue?vue&type=script&lang=ts"
export * from "./editCompanyModal.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./editCompanyModal.vue?vue&type=style&index=0&id=2df34d1e&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2df34d1e",
  null
  ,true
)

export default component.exports